import { FieldValues, UseFormReturn } from 'react-hook-form';

import { AllowanceProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/AllowanceProposalForm/data';
import { BenefitProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BenefitProposalForm/data';
import { BillableHoursProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BillableHoursProposalForm/data';
import { BonusProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BonusProposalForm/data';
import { LegacyProposalRequestProps } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/Common/data';
import { SalaryProposalFormData } from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/SalaryProposalForm/data';

export type EmployeeProposalUpdateCallbackProps = {
  isNewCreated?: boolean;
};

export type EmployeeProposalUpdateCallback = (
  props?: EmployeeProposalUpdateCallbackProps,
) => void;

export type CommonEmployeeProposalFormData = {
  employmentId: string | number;
  responsibleHR: number | string;
};

export type CommonEmployeeProposalFormProps = {
  employeeId: number;
  isNewProposal?: boolean;
  onProposalUpdate: EmployeeProposalUpdateCallback;
};

export type CommonEmployeeProposalFormHandle = {
  handleSubmit: (decision?: EmployeeProposalDecision) => void;
};

export type CommonLegacyAPIPayloadProps = {
  managerId: number;
  higherManagerId: number;
  hrId: number;
  status: string;
};

//TODO SHOULD BE GLOBALLY GENERAL
export enum EmployeeProposalDecision {
  Approve = 'approve',
  Reject = 'reject',
}

export type EmployeeProposalFormData =
  | AllowanceProposalFormData
  | BenefitProposalFormData
  | BillableHoursProposalFormData
  | BonusProposalFormData
  | SalaryProposalFormData;

export type EmployeeProposalFormDataWithAttachment = Exclude<
  EmployeeProposalFormData,
  | AllowanceProposalFormData
  | BillableHoursProposalFormData
  | BonusProposalFormData
>;

export type CommonFormDataToLegacyPayloadProps<T> = {
  data: T;
  isHRUser?: boolean;
  loggedInEmployeeId: number;
  legacyProps?: CommonLegacyAPIPayloadProps;
  decision?: EmployeeProposalDecision;
  requestProps: LegacyProposalRequestProps;
};

export type EmployeeProposalResponsibleHRSelectorSettings = {
  options: number[];
  isResponsibleHR: boolean;
  enabled: boolean;
};

export type UseCommonProposalFormOutput<TFormData extends FieldValues> = {
  form: UseFormReturn<TFormData>;
  handleFormSubmit: (decision?: EmployeeProposalDecision) => () => void;
  handleFormReset: () => void;
  responsibleHRSelector: EmployeeProposalResponsibleHRSelectorSettings;
  isLoading: {
    responsibleHR: boolean;
    commonFieldProps: boolean;
  };
  readOnlyMode: boolean;
  canSubmitForm: (isFormDirty: boolean) => boolean;
};

export type CommonProposalFieldProps = {
  datePickers: {
    startDate: {
      minDate?: Date;
      maxDate?: Date;
    };
    endDate: {
      minDate?: Date;
      maxDate?: Date;
    };
  };
};

export type CommonLegacySubmitAttachmentData = {
  fEmplAttachment: {
    fAttachmentId: number;
    fAttachmentName?: string;
  };
};
